import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { useRouterActions } from 'react-resource-router';
import Button from '@atlaskit/button/standard-button';
import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { useFlags } from '@atlaskit/flag';
import ExcelSpreadsheet24Icon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/24';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { Popup } from '@atlaskit/popup';
import ProgressBar from '@atlaskit/progress-bar';
import { R500 } from '@atlaskit/theme/colors';
import { useExportController } from '../../../../../services/export';
import { CopyDirectLink } from './copy-direct-link';
import { CopyProjectFormModal } from './copy-project-form-modal';
import { DeleteProjectFormModal } from './delete-project-form-modal';
import { DuplicateFormAction } from './duplicate';
import { messages } from './messages';
import { FlagParagraph } from './styled';
export const FormActions = ({
  projectType,
  simplifiedProject,
  userIsProjectAdmin,
  form,
  projectKey,
  issueFormsInfo
}) => {
  const [{
    error,
    filename,
    formId,
    serverProgress,
    successful
  }, {
    clear,
    start
  }] = useExportController();
  const {
    showFlag
  } = useFlags();
  const {
    push
  } = useRouterActions();
  const {
    formatMessage
  } = useIntl();
  const [showCopyFormModal, setShowCopyFormModal] = useState(false);
  const [showDeleteFormModal, setShowDeleteFormModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const issueFormInfo = issueFormsInfo === null || issueFormsInfo === void 0 ? void 0 : issueFormsInfo.filter(f => f.projectFormId === form.id);
  useEffect(() => {
    let icon = /*#__PURE__*/React.createElement(ExcelSpreadsheet24Icon, {
      label: ""
    });
    let title;
    let description;
    if (error) {
      icon = /*#__PURE__*/React.createElement(CrossCircleIcon, {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${R500})`
      });
      title = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.downloadFlagErrorTitle, {
        values: {
          filename
        }
      }));
      description = /*#__PURE__*/React.createElement(FormattedMessage, messages.downloadFlagErrorDescription);
      clear();
    } else if (successful) {
      title = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.downloadFlagCompleteTitle, {
        values: {
          filename
        }
      }));
      clear();
    } else if (serverProgress !== undefined) {
      title = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.downloadFlagTitle, {
        values: {
          filename
        }
      }));
      description = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressBar, {
        value: serverProgress / 100
      }), /*#__PURE__*/React.createElement(FlagParagraph, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.downloadFlagPercentComplete, {
        values: {
          percentCount: serverProgress
        }
      }))));
    }
    if (title !== undefined) {
      showFlag({
        id: `export-${formId}`,
        icon,
        title,
        description
      });
    }
  }, [clear, error, filename, formId, serverProgress, showFlag, successful]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popup, {
    isOpen: isOpen,
    onClose: () => setIsOpen(false),
    placement: "bottom-start",
    shouldRenderToParent: true,
    trigger: ({
      ...providedProps
    }) => /*#__PURE__*/React.createElement(Button, _extends({}, providedProps, {
      appearance: "subtle",
      id: `more_actions${form.id}`,
      "aria-labelledby": `more_actions${form.id} ${form.name.replace(/\s+/g, '')}-${form.id}`,
      iconBefore: /*#__PURE__*/React.createElement(MoreIcon, {
        label: formatMessage(messages.moreActions)
      }),
      onClick: () => setIsOpen(!isOpen)
    })),
    content: () => /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(DropdownItem, {
      onClick: () => push(form.editUrl)
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.edit)), /*#__PURE__*/React.createElement(DuplicateFormAction, {
      form: form
    }), /*#__PURE__*/React.createElement(CopyDirectLink, {
      projectType: projectType,
      projectKey: projectKey,
      simplifiedProject: simplifiedProject,
      issueFormInfo: issueFormInfo,
      onCloseParent: () => setIsOpen(false)
    }), /*#__PURE__*/React.createElement(DropdownItem, {
      onClick: () => setShowCopyFormModal(true)
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.copyLabel)), /*#__PURE__*/React.createElement(DropdownItem, {
      onClick: () => setShowDeleteFormModal(true)
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.deleteLabel)), userIsProjectAdmin && /*#__PURE__*/React.createElement(DropdownItem, {
      isDisabled: formId !== undefined,
      onClick: () => start(form)
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.exportInXlsx)))
  }), showCopyFormModal && /*#__PURE__*/React.createElement(CopyProjectFormModal, {
    onClose: () => setShowCopyFormModal(false),
    formToCopy: form
  }), showDeleteFormModal && /*#__PURE__*/React.createElement(DeleteProjectFormModal, {
    isServiceProject: projectType === 'service_desk',
    form: form,
    onClose: () => setShowDeleteFormModal(false)
  }));
};